<template>
  <v-card>
    <v-card-title>
      Tariff Details
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="editTariffOpen=true;"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Tariff Name</p>
          <p><b>{{getWebsiteTariffByID.name | customPlaceholder}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Tariff Price</p>
          <p><b>{{getWebsiteTariffByID.price | formatCurrency}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Contract Length</p>
          <p><b>{{getCurrentProduct.contract_length_months | monthName}}</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Promo Length</p>
          <p><b>{{getWebsitePromoByID.name | customPlaceholder}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Promo Price</p>
          <p><b>{{getWebsitePromoByID.price | formatCurrency}}</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="mb-1 text-caption">Add-ons</p>
          <template v-if="getCurrentProduct.addons.length===0">
            <p><b>No addons selected</b></p>
          </template>
          <template v-else>
            <v-chip-group column>
              <template v-for="(item,itemI) in getCurrentProductAddons">
                <v-chip x-small :key="itemI">{{item.name}} x {{item.quantity}} ({{item.total}})</v-chip>
              </template>
            </v-chip-group>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
    <WebsiteTariffDetailsDialog :dialogOpen="editTariffOpen" @close-dialog="editTariffOpen=false;" />
  </v-card>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";
  import WebsiteTariffDetailsDialog from './WebsiteTariffDetailsDialog';
  export default {
    components: {WebsiteTariffDetailsDialog},
    data() {
      return { editTariffOpen: false }
    },
    filters: {
      monthName(val){
        if(val==null||val==undefined||val==''){ return '-'; }
        return (val===1)?`Month to month`:`${val} Months`;
      },
    },
    computed: {
      ...mapGetters('productWebsite',['getCurrentProduct','getCurrentProductAddons','getWebsiteTariffs','getWebsiteTariffByID','getWebsitePromoByID']),
    },
  }
</script>

<style lang="scss" scoped>

</style>
